import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { ColorTheme, ShadowTheme, BorderRadiusTheme } from '../../../components/globaStyledComponents/globalStyledComponentsStyling';
import CloudMap from '../../../components/map/CloudMap';
import GlobalPopupContainerCenter from '../../../components/globalPopup/GlobalPopupContainerCenter';
import useClickOutside from '../../../hook/useClickOutside';
import useIsDesktopSize from '../../../hook/useIsDesktopSize';
import CustomZoomControls from '../components/CustomZoomControls';

const MapContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;


interface ViewListingMapPopupProps {
    isOpen: boolean;
    onClose: () => void;
    lat: number;
    lng: number;
    listingTitle: string;
}

const ViewListingMapPopup: React.FC<ViewListingMapPopupProps> = ({ 
    isOpen, 
    onClose, 
    lat, 
    lng, 
    listingTitle 
}) => {
    const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null);
    const wrapperRef = useClickOutside(isOpen, () => {
        onClose();
    });
    const isDesktopSize = useIsDesktopSize();

    const handleMapLoad = useCallback((map: google.maps.Map) => {
        console.log('Map popup loaded:', map);
        setMapInstance(map);
    }, []);

    const handleZoomIn = useCallback(() => {
        if (mapInstance) {
            const currentZoom = mapInstance.getZoom() || 16;
            const newZoom = Math.min(currentZoom + 1, 18);
            mapInstance.setZoom(newZoom);
        }
    }, [mapInstance]);

    const handleZoomOut = useCallback(() => {
        if (mapInstance) {
            const currentZoom = mapInstance.getZoom() || 16;
            const newZoom = Math.max(currentZoom - 1, 10);
            mapInstance.setZoom(newZoom);
        }
    }, [mapInstance]);

    if (!isOpen) return null;

    return (
        <GlobalPopupContainerCenter
            ref={wrapperRef}
            backBtnType={"Close"}
            closePopup={onClose}
            noContinueBtn={true}
            noCancelBtn={true}
            desktopWidth="calc(100vw - 160px)"
            height="calc(100vh - 12px)"
            desktopHeight="80vh"
        >
            <MapContainer>
                <CloudMap
                    containerStyle={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                    }}
                    lat={lat}
                    lng={lng}
                    zoom={16}
                    minZoom={10}
                    maxZoom={18}
                    scrollWheelZoom={true}
                    gestureHandling="greedy"
                    zoomControl={false}
                    onMapLoad={handleMapLoad}
                />
                {mapInstance && (
                    <>
                        {console.log('Rendering CustomZoomControls with mapInstance:', mapInstance)}
                        <CustomZoomControls 
                            onZoomIn={handleZoomIn} 
                            onZoomOut={handleZoomOut} 
                        />
                    </>
                )}
            </MapContainer>
        </GlobalPopupContainerCenter>
    );
};

export default ViewListingMapPopup;
